import { dispatchNetworkEvent } from './event-bus';

const scope = typeof globalThis !== 'undefined'
	? globalThis
	: typeof window !== 'undefined'
		? window
		: typeof self !== 'undefined'
			? self
			: {};

const guardKey = '__epicNetworkSessionExpanderWrapped';
const maxGuardAttempts = 120;
let guardInterval = null;
let guardAttempts = 0;

const patchSessionExpander = () => {
	const sessionExpander = scope.bxSession;

	if (!sessionExpander || typeof sessionExpander.CheckResult !== 'function') return false;

	if (sessionExpander[guardKey]) return true;

	const originalCheckResult = sessionExpander.CheckResult;

	sessionExpander.CheckResult = function epicNetworkSessionCheckResult(data) {
		if (data === 'SESSION_EXPIRED') {
			dispatchNetworkEvent('epic:network:session_expired', {
				reason: 'session_expander',
				source: 'bitrix.session'
			});

			// Let Bitrix update its internal timestamps without opening its legacy notifier.
			return originalCheckResult.call(this, 'SESSION_HANDLED');
		}

		return originalCheckResult.apply(this, arguments);
	};

	sessionExpander[guardKey] = true;
	return true;
};

const ensureSessionGuard = () => {
	if (patchSessionExpander()) {
		if (guardInterval) {
			clearInterval(guardInterval);
			guardInterval = null;
		}

		return;
	}

	if (guardInterval) return;

	guardInterval = setInterval(() => {
		guardAttempts += 1;

		if (patchSessionExpander() || guardAttempts >= maxGuardAttempts) {
			clearInterval(guardInterval);
			guardInterval = null;
		}
	}, 500);
};

export { ensureSessionGuard };
